import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { debounceTime } from "rxjs/operators";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { BrokerDetail } from "src/app/store/models/global-subheader.model";
import { GlobalSubheaderDataService } from "../global-subheader-data.service";
import {
  SetBrokerList,
  SetEntitlementList,
} from "src/app/store/actions/global-subheader.actions";
import { AppService } from "src/app/app.service";
import { EntitlementStatusViewModel } from "src/app/entitlements/entitlements.model";
import { EntitlementsDataService } from "src/app/entitlements/entitlements-data.service";
import { NzMessageService } from "ng-zorro-antd/message";
import {
  VAIconRegistryService,
  arrowLeft,
  arrowRight,
  exclamationTriangle,
} from "@va/core-library/icons";
@Component({
  selector: "app-request-modal-dep",
  templateUrl: "./request-modal.component.html",
  styleUrls: ["./request-modal.component.scss"],
})
export class RequestModalComponent implements OnInit {
  @Input() modalContext: string;
  @Input() visible: boolean;

  @Output() onRequestBroker: EventEmitter<any> = new EventEmitter();
  @Output() onRequestEntitlement: EventEmitter<any> = new EventEmitter();
  @Input() selectedBrokerId: string;
  @Input() selectedType: string;
  @Output() onRequest: EventEmitter<any> = new EventEmitter();
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  brokerList = [];
  entitlements: Array<EntitlementStatusViewModel> = [];
  countries: Array<string> = [];
  states: Array<string> = [];
  stagedToAddBrokerIndices = [];
  stagedToRemoveBrokers = [];
  selectedBrokers = [];
  queryField: UntypedFormControl = new UntypedFormControl();
  modalWidth: string;
  modalTitle: string;
  modalOkText: string;
  requestDisable = false;
  errorText = "";
  detailsErrorText = "";
  countryNotFoundText = "";
  stateNotFoundText = "";
  details = {
    address1: "",
    address2: "",
    city: "",
    zip: "",
    country: null,
    state: null,
    tel: "",
    role: "",
  };
  entErrorText: string;
  countryFilter = (input, option) => {
    if (option.nzValue.toLowerCase().includes(input.toLowerCase())) {
      this.countryNotFoundText = "";
      return true;
    }

    this.countryNotFoundText = input;
    return false;
  };

  stateFilter = (input, option) => {
    if (option.nzValue.includes(input)) {
      this.stateNotFoundText = "";
      return true;
    }

    this.stateNotFoundText = input;
    return false;
  };
  firmName: string;

  constructor(
    private store: Store<AppState>,
    private dataService: GlobalSubheaderDataService,
    private appService: AppService,
    private entitlementsService: EntitlementsDataService,
    private message: NzMessageService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([
      arrowRight,
      arrowLeft,
      exclamationTriangle,
    ]);
  }

  ngOnInit() {
    this.queryField.valueChanges.pipe(debounceTime(200)).subscribe((text) => {
      this.brokerList = this.applyBrokerFilter(text);
    });
    this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data) => {
        this.firmName = data.firm_name;
      });
  }

  dummy() {
    return 5;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.modalContext &&
      changes.modalContext.currentValue !== undefined
    ) {
      this.modalContext = changes.modalContext.currentValue;

      if (this.modalContext === "requestNewBroker") {
        this.modalWidth = "775px";
        this.modalTitle = "Request Broker Participation";
        this.modalOkText = "Request Brokers";
        this.getBrokerList();
      } else {
        this.modalWidth = "1024px";
        this.modalTitle = "Request Entitlements";
        this.modalOkText = "Request Entitlements";
        if (this.entitlements.length === 0) {
          this.entitlementsService.getEntitlementsStatus().subscribe(
            (data) => {
              if (data.status === "success") {
                this.entitlements = data.data.map((ent) => {
                  const modelStatus = this.entitlementsService.decodeStatus(
                    ent.fin_st,
                  );
                  const researchStatus = this.entitlementsService.decodeStatus(
                    ent.res_st,
                  );
                  return {
                    brokerName: ent.b_name,
                    model: modelStatus,
                    research: researchStatus,
                  };
                });
                this.getBrokerList();
                this.entitlementsService.getPersonalDetails().subscribe((d) => {
                  if (d.status === "success") {
                    if (!d.data.state) {
                      d.data.state = null;
                    }
                    if (!d.data.country) {
                      d.data.country = null;
                    }
                    this.details = d.data as any;
                  }
                });
              } else {
                console.error("Get Entitlement Status failed");
              }
            },
            (err) => {
              console.error(err);
            },
          );
        } else {
          this.getBrokerList();
        }

        if (this.countries.length === 0) {
          this.entitlementsService.getCountryList().subscribe((data) => {
            this.countries = data.data;
          });
        }

        if (this.states.length === 0) {
          this.entitlementsService.getStatesList().subscribe((data) => {
            this.states = data.data;
          });
        }
      }
    }
  }

  getBrokerList() {
    if (this.brokerList.length === 0 && this.visible) {
      this.store
        .select(
          stateGetter(
            "globalSubheader",
            this.modalContext === "requestNewBroker"
              ? "brokerList"
              : "entitlementList",
          ),
        )
        .subscribe((data: Array<BrokerDetail>) => {
          if (data.length) {
            setTimeout(() => {
              this.brokerList = data.map((d) => {
                if (this.modalContext === "requestEntitlement") {
                  const ent = this.entitlements.find((e) => {
                    return e.brokerName === d.name;
                  });
                  return {
                    id: d.id,
                    label: d.name,
                    value: d.name,
                    checked: false,
                    visible: true,
                    disabled: false,
                    modelLabel: ent.model.label,
                    resLabel: ent.research.label,
                  };
                }

                return {
                  id: d.id,
                  label: d.name,
                  value: d.name,
                  checked: false,
                  visible: true,
                  disabled: false,
                };
              });
              this.setIfbrokerSelected();
            }, 1);
          } else {
            this.dataService
              .getBrokerList(
                this.modalContext === "requestNewBroker"
                  ? "brokers"
                  : "entitlements",
              )
              .subscribe((data) => {
                if (this.modalContext === "requestNewBroker") {
                  this.store.dispatch(new SetBrokerList(data.data));
                } else {
                  this.store.dispatch(new SetEntitlementList(data.data));
                }
              });
          }
        });
    }
  }
  setIfbrokerSelected() {
    const list = this.brokerList;
    if (this.selectedBrokerId) {
      const id = list.findIndex((d) => d.id === this.selectedBrokerId);
      if (id !== -1) {
        this.stagedToAddBrokerIndices = [id];
        this.addToSelectedBrokers(
          this.selectedType === "r",
          this.selectedType === "m",
        );
      }
    }
  }
  countrySelectionChanged(value) {
    if (value !== "United States") {
      this.details.state = null;
      this.stateNotFoundText = "";
    }
  }

  onAvailableBrokerSelect(brokersIndices) {
    this.stagedToAddBrokerIndices = brokersIndices;
  }

  onSelectedBrokerSelect(brokers) {
    this.stagedToRemoveBrokers = brokers;
  }

  addToSelectedBrokers(st_r = false, st_m = false) {
    const newselectedBrokers = this.stagedToAddBrokerIndices.map((i) => {
      this.brokerList[i].disabled = true;
      this.brokerList[i].checked = false;
      if (this.modalContext === "requestNewBroker") {
        return {
          id: this.brokerList[i].id,
          name: this.brokerList[i].label,
          email: "",
          checked: false,
          brokerIndex: i,
          hasError: false,
          st_r,
          st_m,
        };
      }

      return {
        id: this.brokerList[i].id,
        name: this.brokerList[i].label,
        modelLabel: this.brokerList[i].modelLabel,
        resLabel: this.brokerList[i].resLabel,
        email: "",
        checked: false,
        brokerIndex: i,
        hasError: false,
        st_r,
        st_m,
      };
    });
    this.selectedBrokers = this.selectedBrokers.concat(newselectedBrokers);
    this.stagedToAddBrokerIndices = [];
    this.errorText = "";
    this.entErrorText = "";
  }

  removeSelectedBrokers() {
    const newselectedBrokers = this.selectedBrokers.filter((b) => {
      if (this.stagedToRemoveBrokers.includes(b.name)) {
        this.brokerList[b.brokerIndex].disabled = false;
        this.brokerList[b.brokerIndex].checked = false;
        return false;
      }

      return true;
    });
    this.selectedBrokers = newselectedBrokers;
    this.stagedToRemoveBrokers = [];
    this.errorText = "";
    this.entErrorText = "";
  }

  handleCancelModal(event) {
    this.visible = false;
    this.closeModal(event);
  }
  handleOkModal() {
    const validatedList = [];
    this.validateSelectedBrokers(validatedList);

    if (this.modalContext === "requestEntitlement") {
      //user_info
      //request_data = validatedList + st_r, st_m
      //id_list => id from validatedList

      this.validateUserDetails();
      if (
        this.errorText.length === 0 &&
        this.detailsErrorText.length === 0 &&
        this.entErrorText.length === 0
      ) {
        const data = {
          list: validatedList.map((val) => val.id),
          data: this.details,
          requestData: validatedList,
        };
        this.onRequestEntitlement.emit(data);
        this.onRequestEntitlementClick(data);
      }
    } else {
      if (this.errorText.length === 0) {
        this.onRequestBroker.emit(validatedList);
        this.onRequestBrokerClick(validatedList);
      }
    }
  }

  validateSelectedBrokers(validatedList = []) {
    if (this.selectedBrokers.length === 0) {
      this.errorText = "Please choose a broker to request";
      return;
    }
    this.errorText = "";
    this.entErrorText = "";
    if (this.modalContext === "requestEntitlement") {
      this.selectedBrokers.forEach((sb) => {
        let email = sb.email;
        email = email.toLowerCase().trim();
        const validationResponse = this.appService.verifyEmailAddress(email);
        const noneSelected = !sb.st_m && !sb.st_r;
        if (!validationResponse.hasError && !noneSelected) {
          sb.hasError = false;
          validatedList.push({
            id: sb.id,
            email: email,
            st_r: sb.st_r !== undefined ? sb.st_r : false,
            st_m: sb.st_m !== undefined ? sb.st_m : false,
          });
        } else {
          if (validationResponse.hasError) {
            this.errorText =
              "Please provide valid email addresses for your sales contact(s)";
          }
          if (noneSelected) {
            this.entErrorText =
              "Please select a content set for the entitlement request";
          }
          sb.hasError = true;
        }
      });
    } else {
      this.selectedBrokers.forEach((sb) => {
        let email = sb.email;
        email = email.toLowerCase().trim();
        const validationResponse = this.appService.verifyEmailAddress(email);
        if (!validationResponse.hasError) {
          sb.hasError = false;
          validatedList.push({
            id: sb.id,
            email: email,
          });
        } else {
          this.errorText =
            "Please provide valid email addresses for your sales contact(s)";
          sb.hasError = true;
        }
      });
    }
  }

  validateUserDetails() {
    this.detailsErrorText = "";
    if (
      !this.details.address1 ||
      !this.details.address2 ||
      !this.details.city ||
      !this.details.country ||
      (this.details.country === "United States" && !this.details.state) ||
      !this.details.zip
    ) {
      this.detailsErrorText = "Please complete the missing fields";
      return;
    }
  }

  closeModal(event) {
    this.onClose.emit(true);
    this.clearStates();
    if (!event) {
      //Workaround since ant modal doesnt pass event value and we need it to trigger loguseraction
      event = "closeevent";
    }
    this.appService.logUserAction(
      event,
      "",
      "",
      "REQUEST_PROVIDER_CLOSE",
      { url: window.location.href },
      "",
      "",
    );
  }

  clearStates() {
    this.resetBrokerFilters();
    this.queryField.setValue("");
    this.detailsErrorText = "";
    this.countryNotFoundText = "";
    this.stateNotFoundText = "";
    this.details = {
      address1: "",
      address2: "",
      city: "",
      zip: "",
      country: null,
      state: null,
      tel: "",
      role: "",
    };
    this.entitlements = [];
  }

  resetBrokerFilters() {
    this.brokerList = [];
    this.selectedBrokers = [];
    this.stagedToAddBrokerIndices = [];
    this.stagedToRemoveBrokers = [];
    this.errorText = "";
    this.entErrorText = "";
  }

  applyBrokerFilter(text) {
    return this.brokerList.map((b) => {
      return {
        ...b,
        visible:
          text === ""
            ? true
            : b.label.toLowerCase().includes(text.toLowerCase()),
      };
    });
  }
  onRequestEntitlementClick(entitlementObj) {
    this.requestDisable = true;
    const objToSend = {
      id_list: entitlementObj.list,
      user_info: {
        address1: entitlementObj.data.address1,
        address2: entitlementObj.data.address1,
        city: entitlementObj.data.city,
        state:
          entitlementObj.data.country === "United States"
            ? entitlementObj.data.state
            : entitlementObj.data.country,
        country: entitlementObj.data.country,
        zip: entitlementObj.data.zip,
        tel: entitlementObj.data.tel,
        role: entitlementObj.data.role,
      },
      request_data: entitlementObj.requestData,
    };

    this.dataService.requestEntitlement(objToSend).subscribe(
      (response) => {
        if (response.status === "success") {
          this.requestDisable = false;
          this.message.success(
            "Request for entitlements was submitted successfully.",
            {
              nzDuration: 2000,
            },
          );
          this.entitlementsService.updateEntitlementStatus();
          this.closeModal("closeevent");
        } else {
          this.requestDisable = false;
          this.message.error(
            "Unable to complete the request. Please try again.",
            { nzDuration: 2000 },
          );
        }
      },
      () => {
        this.requestDisable = false;
        this.message.error(
          "Unable to complete the request. Please try again.",
          { nzDuration: 2000 },
        );
      },
    );
  }
  onRequestBrokerClick(brokerList) {
    const bccBrokerList = [];
    brokerList.forEach((b) => {
      bccBrokerList.push(b.email);
    });
    this.dataService.requestBrokers(brokerList).subscribe((response) => {
      if (response.status === "success") {
        this.message.success("Request for brokers was submitted successfully", {
          nzDuration: 2000,
        });
        const mailBody =
          `${this.firmName} is using Visible Alpha Insights to view financial models and we would like to access your model data through this service.` +
          `%0D%0A%0D%0A` +
          `The Visible Alpha team will contact your Research department regarding contribution of models but we'd appreciate any assistance you can provide in facilitating this request.` +
          `%0D%0A%0D%0A` +
          `Thanks in advance for your attention and help in this matter.`;

        const mailToString =
          `${
            "mailto:" +
            "?subject=Request for Access to Models Over Visible Alpha Insights" +
            "&bcc="
          }${bccBrokerList.toString()}&cc=contributorrelations@visiblealpha.com` +
          `&body=${mailBody}`;
        window.location.href = mailToString;
        this.entitlementsService.updateEntitlementStatus();
        this.closeModal("closeevent");
      } else {
        this.message.error(
          "Unable to complete the request. Please try again.",
          { nzDuration: 2000 },
        );
      }
    });
  }
}
